import React, { useEffect, useState } from 'react';
import PreviewHeader from './PreviewHeader';
import ResizablePanel from './ResizablePanel';
import PreviewTreeNavigation from '../preview/PreviewTreeNavigation';
import ShareFormModal from '../../pages/ShareFormModal/ShareFormModal';
import { usePanelResize } from '../../hooks/usePanelResize';
import './builder-shell.scss';
import './preview-shell.scss';

const PreviewShell = ({
  children,
  formdata,
  activeSectionId,
  activeQuestionId,
  onSelectSection,
  onSelectSubSection,
  onSelectRootFields,
  onSelectQuestion,
  onPublish,
  canPublish,
  isPublished,
  languageSelector,
  userFullName,
}) => {
  const { widths, setSidebarWidth } = usePanelResize();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 1024);
  const [searchQuery, setSearchQuery] = useState('');
  const [showShare, setShowShare] = useState(false);

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(true);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div
      className="builder-shell preview-shell"
      style={{
        '--builder-sidebar-width': (sidebarOpen && !isMobile) ? `${widths.sidebar}px` : '0px',
        '--builder-panel-width': '0px',
      }}
    >
      <PreviewHeader
        userFullName={userFullName}
        formName={formdata?.name}
        sidebarOpen={sidebarOpen}
        onToggleSidebar={() => setSidebarOpen((v) => !v)}
        onShare={() => setShowShare(true)}
        onPublish={onPublish}
        canPublish={canPublish}
        isPublished={isPublished}
        languageSelector={languageSelector}
      />

      <div className="builder-shell__body">
        {isMobile && sidebarOpen && (
          <button
            type="button"
            className="builder-sidebar-backdrop"
            aria-label="Close sidebar"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {sidebarOpen && (
          <ResizablePanel
            id="preview-sidebar"
            width={widths.sidebar}
            onResize={setSidebarWidth}
            side="left"
          >
            <PreviewTreeNavigation
              formdata={formdata}
              activeSectionId={activeSectionId}
              activeQuestionId={activeQuestionId}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              onSelectSection={onSelectSection}
              onSelectSubSection={onSelectSubSection}
              onSelectRootFields={onSelectRootFields}
              onSelectQuestion={onSelectQuestion}
            />
          </ResizablePanel>
        )}

        <div className="builder-shell__canvas-wrap">
          {children}
        </div>
      </div>

      {showShare && formdata && (
        <ShareFormModal
          modalShow={showShare}
          data={formdata}
          callbackModal={() => setShowShare(false)}
        />
      )}
    </div>
  );
};

export default PreviewShell;
